import React, { useEffect, useState, createContext, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { checkAuthenticated, load_user } from '../actions/auth';
import Profile from '../components/Profile';

const ChatShellContext = createContext(null);

export function useChatShell() {
  const ctx = useContext(ChatShellContext);
  if (!ctx) {
    throw new Error('useChatShell must be used within ChatShell');
  }
  return ctx;
}

const ChatShell = ({ checkAuthenticated, load_user, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth >= 1024 : true
  );
  const [profileTrigger, setProfileTrigger] = useState(false);
  const [activeChatId, setActiveChatId] = useState(null);

  useEffect(() => {
    checkAuthenticated();
    load_user();
  }, [checkAuthenticated, load_user]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      }
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const value = useMemo(
    () => ({
      sidebarOpen,
      setSidebarOpen,
      activeChatId,
      setActiveChatId,
      openProfile: () => setProfileTrigger(true),
    }),
    [sidebarOpen, activeChatId]
  );

  return (
    <ChatShellContext.Provider value={value}>
      <div className="chat-shell h-dvh overflow-hidden bg-surface-alt text-text-primary">
        {children}
        <Profile trigger={profileTrigger} setTrigger={setProfileTrigger} />
      </div>
    </ChatShellContext.Provider>
  );
};

export default connect(null, { checkAuthenticated, load_user })(ChatShell);
